module.exports = __webpack_public_path__ + "static/biz-ele-6b45e31bd6a4aecf2d5841c34c0ffeb9.jpg";